import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { CircularProgress, Typography } from '@mui/material';

import useErrorManager from "../../../hooks/useErrorManager";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";

import NetworkInfo from './NetworkInfo';
import NetworkActionsList from './NetworkActionsList';

import { useBreadcrumb } from '../../../contexts/BreadcrumbContext'; // Import breadcrumb context


function NetworkDetails() {
    const { networkId } = useParams();
    const [details, setDetails] = useState(null);

    const { setError, clearError, getError } = useErrorManager();
    const [loading, setLoading] = useState(true);
    
    const { updateBreadcrumb } = useBreadcrumb(); 

    const axiosInstance = useAxiosPrivate();

    useEffect(() => {
        const fetchNetworkDetails = async () => {
            try {
                const response = await axiosInstance.get(`/net/${networkId}/details`);
                setDetails(response.data);
                clearError('fetchNetDetails');
                setLoading(false);

                updateBreadcrumb([
                    { label: 'Manage networks', link: '/networks' },
                    { label: `NW_${response.data.networkNumber}` || 'Network', link: null }, // Dynamically set location name
                ]);

            } catch (error) {
                setError('fetchNetDetails', error.message);
                setLoading(false);
            }
        };

        fetchNetworkDetails();
    }, [networkId]);
    
    if (loading) return <CircularProgress />;
    if (getError('fetchNetDetails')) return <Typography variant="h7">{getError('fetchNetDetails')}</Typography>;

    return (
        <>
            <NetworkInfo
                details={details}
            />
        </>
    );
}

export default NetworkDetails; 
